@if (model?.data) {
<div class="pos-relative flex flex-column height-100 page page--blog-post">
    <!-- picture -->
    <href [link]="model.data.url">
        <img class="w-12"
             [dfImage]="model.data.image"
             ratio="3/4">
    </href>
    <!-- content -->
    <div class="pos-relative flex-grow p-r-8-x p-r-8-l p-l-8-x p-l-8-l">
        <!-- date -->
        @if (model.data.createdAt) {
        <p class="m-t-2 fs-2 lh-2 uppercase">
            {{model.data.createdAt | date: 'dd' | ordinal}}
            {{model.data.createdAt | date: 'MMMM yyyy'}}</p>
        }
        <!-- title -->
        <href [link]="model.data.url">
            <h3 class="m-t-1 h3">{{model.data.name}}</h3>
        </href>
        <!-- read more -->
        <div class="m-t-1">
            <href [link]="model.data.url">
                <span class="lh-2 fw-bold button-inline">{{'Read Now' | translate}}</span>
            </href>
        </div>
    </div>
</div>
}